import React, { Component } from 'react';
import Carousel from './Carousel';
import './Expertise.scss';

const tech_icons = {
  "items" : [
    { "name" : "Javascript",
      "icon" : "/tech-icons/java.png",
    },
    { "name" : "Objective-C",
      "icon" : "/tech-icons/apple.png",
    },
    { "name" : "Java",
      "icon" : "/tech-icons/java.png",
    },
    { "name" : "Ruby",
      "icon" : "/tech-icons/ruby.png",
    },
    { "name" : "Node JS",
      "icon" : "/tech-icons/node.png",
    },
    { "name" : "HTML5",
      "icon" : "/tech-icons/html5.png",
    },
    { "name" : "JQuery",
      "icon" : "/tech-icons/jquery.png",
    },
    { "name" : "React",
      "icon" : "/tech-icons/react.png",
    },
    { "name" : "Ember",
      "icon" : "/tech-icons/ember.png",
    },
    { "name" : "C#",
      "icon" : "/tech-icons/visual-studio.png",
    },
    { "name" : "Postgres",
      "icon" : "/tech-icons/postgres.png",
    },
    { "name" : "MySQL",
      "icon" : "/tech-icons/mysql.png",
    },
    { "name" : "mongoDB",
      "icon" : "/tech-icons/mongo.png",
    },
    { "name" : "Spark",
      "icon" : "/tech-icons/spark.png",
    },
    { "name" : "beacons",
      "icon" : "/tech-icons/bluetooth.png",
    }
  ]
}

export default class Expertise extends Component {
  render() {
    return (
      <section id="expertise" className="section grey-bg">
        <div className="container">
          <div className="section-title">
            <h2><span>My</span> Expertise</h2>
          </div>

          <div className="row expertise-detail">
            <div className="col-sm-4">
              <div className="service-box">
                <span className="sb-icon">
                  <i className="fa fa-code fa-2x"></i>
                </span>
                <h4>WEB APPLICATIONS</h4>
                <div className="sb-desc">
                  <p>I&apos;ve worked on hundreds of web applications over the years, using a variety of technologies. They are usually driven by data, and use responsive techniques to display properly on any device.</p>
                </div>
              </div>
            </div>

            <div className="col-sm-4">
              <div className="service-box">
                <span className="sb-icon">
                  <i className="fa fa-mobile fa-2x"></i>
                </span>
                <h4>NATIVE MOBILE APPS</h4>
                <div className="sb-desc">
                  <p>I&apos;ve been building native apps for iPhone &amp; iPad, Android, Blackberry, and even Palm Pilot since they were first released. I usually also develop the server-side API, database and management tools for them as well.</p>
                </div>
              </div>
            </div>

            <div className="col-sm-4">
              <div className="service-box">
                <span className="sb-icon">
                  <i className="fa fa-cloud fa-2x"></i>
                </span>
                <h4>DEVOPS</h4>
                <div className="sb-desc">
                  <p>I&apos;ve built &amp; maintained many servers to support these apps, which have evolved over time from physical hardware to virtual machines in cloud services like AWS as well as hosted data sevices.</p>
                </div>
              </div>
            </div>

          </div>

          <div className="row expertise-tech">
            <div className="col-sm-12">

              <h3>My Core Technologies</h3>
              <Carousel opts={tech_icons} />

            </div>
          </div>

        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Expertise.js